import React from 'react'
import Img from 'gatsby-image'
import { StaticQuery, graphql } from 'gatsby'

const MainPartners = () => (
  <StaticQuery
    query={graphql`
      query mainPartnersQuery {
        ideaspace: file(relativePath: { eq: "partners/ideaspace.png" }) {
          childImageSharp {
            id
            fixed(width: 400) {
              originalName
              ...GatsbyImageSharpFixed_withWebp
            }
          }
        }
        innoventures: file(relativePath: { eq: "partners/innoventures.png" }) {
          childImageSharp {
            id
            fixed(width: 400) {
              originalName
              ...GatsbyImageSharpFixed_withWebp
            }
          }
        }
        GIE: file(relativePath: { eq: "partners/GIE.png" }) {
          childImageSharp {
            id
            fixed(width: 400) {
              originalName
              ...GatsbyImageSharpFixed_withWebp
            }
          }
        }
      }
    `}
  >
    {data => {
      const partners = Object.values(data).map(partner => ({
        id: partner.childImageSharp.id,
        name: partner.childImageSharp.fixed.originalName,
        image: partner.childImageSharp.fixed,
      }))

      return (
        <div>
          {partners.map(partner => (
            <Img key={partner.id} alt={partner.name} fixed={partner.image} />
          ))}
        </div>
      )
    }}
  </StaticQuery>
)

export default MainPartners
